<template>
  <span v-if="!edit" class="text-sm">
    {{ formatDate() }}
  </span>

  <DateAnswer v-else v-bind="$attrs" no-label :question="original"/>
</template>


<script>

import {formatDate} from "#functions/formatter.js";

import DateAnswer from '#views/questionnaire/answers/DateAnswer';

export default {
  name: "DatetimeDetail",
  inheritAttrs: false,
  components: {
    DateAnswer
  },
  props: {
    original: {
      type: Object,
      required: true,
    },
    edit: {
      type: Boolean,
      required: true,
    },
    value: {
      required: true,
    },
  },
  data() {
    return {
      formattedValue: null,
    }
  },
  methods:{
    formatDate(){
      const value = formatDate(this.value, this.original.field_type.label === 'date' ? 'DD/MM/YYYY':'DD/MM/YYYY HH:mm');
      return value && value !== 'Invalid date' ? value:'Sem resposta';
    },
  },
  mounted(){
    this.$emit("update:modelValue", this.value);
  },
  watch: {
    value(newer){
      this.$emit("update:modelValue", newer);
    }
  }
};
</script>
